
<template>
  <div>
    <v-tabs
      class="pt-3"
      v-model="tabActive"
      color="white"
      slider-color="primary"
    >
      <v-tab>Prestadores de serviços</v-tab>
      <v-tab class>Prepostos gerentes</v-tab>

      <v-tab-item>
        <ServiceProviders />
      </v-tab-item>
      <v-tab-item>
        <Representative />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import Representative from '@/components/provider/representative/Representative.vue'
import ServiceProviders from '@/components/provider/serviceProviders/ServiceProviders.vue'

export default {
  name: 'ServicesProviders',

  components: {
    Representative,
    ServiceProviders
  },

  data () {
    return {
      tabActive: 0
    }
  }
}
</script>
<style>
</style>
